/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-arrows-vertical': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.619 12.869l-2.244 2.237V2.5h-1.25v12.606l-2.244-2.237-.881.881 3.75 3.75 3.75-3.75-.881-.881zM6.25 2.5L2.5 6.25l.881.881 2.244-2.237V17.5h1.25V4.894L9.119 7.13 10 6.25 6.25 2.5z"/>'
  }
})
